import * as Yup from 'yup';
import { SubjectRegistration } from '../../models';
import { useValidationSchema as subjectSchema } from '../subject/subjects-schema';

export function useValidationSchema() {
  return Yup.object<SubjectRegistration>().shape({
    registrationSubject: subjectSchema(),
  }) as Yup.Schema<SubjectRegistration>;
}
